import { render } from "./ProviderTextAnnotation.vue?vue&type=template&id=91ce60e6&scoped=true"
import script from "./ProviderTextAnnotation.vue?vue&type=script&lang=js"
export * from "./ProviderTextAnnotation.vue?vue&type=script&lang=js"

import "./ProviderTextAnnotation.vue?vue&type=style&index=0&id=91ce60e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ce60e6"]])

export default __exports__